



























































































import { Vue, Prop, Component } from 'vue-property-decorator';
import { PriceDetailedDataExtended } from '@/project/product/services/detailedPriceFetch.service';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';

import loginFormOverlayService from '@/project/modals/overlays/LoginFormOverlay.service';
import gtmService from '@/project/tracking/gtm/GTM.service';
const AddToBasket = () => import(/* webpackChunkName: 'auth-feature' */'@/project/basket/AddToBasket.vue');

@Component({
    components: { AddToBasket, SpinnerOverlay }
})
export default class ProductDetailsCart extends Vue {
    @Prop({ required: true, type: String }) wid!: string;
    @Prop({ required: true }) price!: { loaded: boolean, data: PriceDetailedDataExtended };
    @Prop({ required: false, default: false }) isLoggedIn!: boolean;

    private get loaded(): boolean {
        return this.price?.loaded;
    }

    private get isServiceAvailable(): boolean {
        return this.price.data?.isServiceAvailable ?? false;
    }

    private get isPriceAvailable(): boolean {
        return this.price.data !== null && this.price.data.price !== null;
    }

    private get hasQuantityDiscounts() {
        return this.price.data && this.price.data.discounts && this.price.data?.discounts.length > 0;
    }

    private get suggestedRetailPrice() {
        return this.price.data?.suggestedRetailPrice.cultureFormatted && this.price.data?.suggestedRetailPrice;
    }

    private get formattedPrice() {
        return this.price.data?.price?.cultureFormatted;
    }

    private showLoginOverlay() {
        gtmService.trackLogInToViewPricesClick();
        loginFormOverlayService.show('login');
    }
}
